import React, { useState, useEffect } from 'react';
import { Col } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getAllProducts } from '../../../utils/shopify';
import { getMerchCache } from '../../../actions';
import MerchContent from './MerchContent';

import './Merch.scss';

const Merch = () => {
  const [templates, setTemplates] = useState(null);
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const {
    isLoading,
    data: merchCache,
    pagination,
    rehydrated,
  } = useSelector(state => state.user.merchCache);

  console.log('merchCache:', merchCache);
  console.log('templates:', templates);
  console.log('rehydrated:', rehydrated);

  useEffect(() => {
    if (!rehydrated) {
      console.log('dispatching getLatestMerch');
      dispatch(getMerchCache());
    }
  }, [dispatch, pagination, rehydrated]);

  useEffect(() => {
    const retrieveProducts = async () => {
      try {
        console.log('Fetching templates...');
        const t = await getAllProducts('__templates');
        console.log('Templates fetched:', t);
        setTemplates(() => t);
      } catch (error) {
        console.error('Error fetching templates:', error);
        setTemplates([]); // Set to empty array so component can render
      }
    };

    retrieveProducts();
  }, [user]);

  if (templates === null || !merchCache) {
    return (
      <section className="merch">
        <Col xs={24} sm={24} md={24} lg={22} xl={20} xxl={18}>
          <h1 className="title">Design Your Merch.</h1>
          <div>Loading merch data...</div>
          <div>Templates: {templates ? 'Loaded' : 'Loading...'}</div>
          <div>Merch Cache: {merchCache ? 'Loaded' : 'Loading...'}</div>
          <div>Rehydrated: {rehydrated ? 'Yes' : 'No'}</div>
        </Col>
      </section>
    );
  }

  return (
    <section className="merch">
      <Col xs={24} sm={24} md={24} lg={22} xl={20} xxl={18}>
        <h1 className="title">Design Your Merch.</h1>
        <MerchContent />
      </Col>
    </section>
  );
};

export default Merch;
